import { forwardRef, useMemo } from "react";

import { Icons } from "widgets";

import { getGeneTypeColor } from "../../../../app-utils/color.js";
import { type Transcript } from "../../../../graphql.js";
import { Tile, type TileProps } from "../../../../modules/core/components/Tile.js";
import { ENTITY_TYPE, SEQUENCE_TYPE_LABEL } from "../../../../settings/settings.js";

interface TranscriptTileProps extends Pick<TileProps, "type" | "footNote"> {
  transcript: Transcript;
  hideIcon?: boolean;
}

const TranscriptTile = forwardRef<HTMLDivElement, TranscriptTileProps>(function TranscriptTile(props, ref) {
  const [title, sequenceId] = useMemo(() => {
    const title = props.transcript?.name;
    const sequenceId = props.transcript?.sequenceId;

    return title ? [title, sequenceId] : [sequenceId, undefined];
  }, [props.transcript]);

  if (props.transcript == undefined) return null;

  const transcriptType: string = SEQUENCE_TYPE_LABEL[props.transcript.sequenceTypeId];

  return (
    <Tile
      title={title}
      subtitle={sequenceId}
      to={`/${ENTITY_TYPE.TRANSCRIPT}/${props.transcript.id}`}
      type={props.type !== undefined ? props.type : "Transcript"}
      footNote={props.footNote}
      icon={props.hideIcon !== true ? <img src={Icons.Tiles.Entity} width={24} height={30} /> : undefined}
      ref={ref}
      tags={transcriptType ? [{ label: transcriptType, intentColor: getGeneTypeColor(transcriptType) }] : null}
    >
      {props.transcript.description}
    </Tile>
  );
});

export { TranscriptTile };
